import dateFormat from 'dateformat';
import events from 'events';

const DATE_FORMAT = 'mm/dd/yyyy';

function sortFunc(a, b) {
  if (a.PERMITTEE > b.PERMITTEE) return 1;
  if (a.PERMITTEE < b.PERMITTEE) return -1;
  return 0;
}

function sortFuncLakeReport(a, b) {
  if (a.Permittee > b.Permittee) return 1;
  if (a.Permittee < b.Permittee) return -1;
  return 0;
}

const ReportBuilder = {
  buildReport({ permittees, year, month }) {
    const emitter = new events.EventEmitter();

    (async () => {
      const data = {};
      data.permittees = await this.pullPermitsForPermittees(
        permittees,
        emitter
      );

      data.hearing = await this.getHearing(year, month);
      emitter.emit('Progress', 76);

      data.continuedApplicants = await this.pullContinuedApplicants(
        year,
        month
      );
      emitter.emit('Progress', 79);

      data.adminModifications = await this.pullAdministrativeModifications(
        year,
        month
      );
      emitter.emit('Progress', 82);

      data.advertisedInError = await this.pullAdvertisedInError(year, month);
      emitter.emit('Progress', 85);

      data.cancelled = await this.pullCancelled(year, month);
      emitter.emit('Progress', 88);

      data.lakeReport = await this.pullLakeReport(year, month);
      emitter.emit('Progress', 92);

      data.newWells = await this.pullNewWells(year, month);
      emitter.emit('Progress', 95);

      data.takeNoAction = await this.pullTakeNoAction(year, month);
      emitter.emit('Progress', 100);

      emitter.emit('Done', data);
    })();

    return emitter;
  },

  pullPermitsForPermittees(permittees, emitter) {
    const total = permittees.length;
    return new Promise(async (resolve, reject) => {
      let count = 0;
      for (let permittee of permittees) {
        const permitData = await this.getPermits(permittee.permits);
        for (let permit of permitData) {
          const { reportYear, pumpage } = await this.getAnnualReportPumpage(
            permit
          );
          permit.reportYear = reportYear;
          permit.pumpage = pumpage;
          const diameter = await this.getDiameter(permit);
          permit.diameter = diameter;
          /* Get Allocation Information */
          const { termBegin, termEnd, allocation } =
            await this.getAllocationAmount(permit);
          permit.termBegin = termBegin;
          permit.termEnd = termEnd;
          permit.allocation = allocation;
        }
        console.log('permitData:');
        console.log(permitData);
        permittee.permitData = permitData;
        count++;

        emitter.emit('Progress', Math.round((count / total) * (3 / 4) * 100));
      }
      resolve(permittees);
    });
  },

  pullContinuedApplicants(year, month) {
    return new Promise(async (resolve, reject) => {
      const { apiUrl } = window['config'];
      const response = await fetch(
        `${apiUrl}/appendix/continuedApplicants/${year}/${month}`
      );
      const casesResult = await response.json();
      casesResult.sort(sortFunc);
      resolve(casesResult);
    });
  },

  pullAdministrativeModifications(year, month) {
    return new Promise(async (resolve, reject) => {
      const { apiUrl } = window['config'];
      const response = await fetch(
        `${apiUrl}/appendix/AdministrativeModifications/${year}/${month}`
      );
      const casesResult = await response.json();
      resolve(casesResult);
    });
  },

  pullAdvertisedInError(year, month) {
    return new Promise(async (resolve, reject) => {
      const { apiUrl } = window['config'];
      const response = await fetch(
        `${apiUrl}/appendix/advertisedInError/${year}/${month}`
      );
      const casesResult = await response.json();
      resolve(casesResult);
    });
  },

  pullCancelled(year, month) {
    return new Promise(async (resolve, reject) => {
      const { apiUrl } = window['config'];
      const response = await fetch(
        `${apiUrl}/appendix/cancelledOutcomes/${year}/${month}`
      );
      const casesResult = await response.json();
      resolve(casesResult);
    });
  },

  pullLakeReport(year, month) {
    return new Promise(async (resolve, reject) => {
      const { apiUrl } = window['config'];
      const response = await fetch(
        `${apiUrl}/appendix/lakeMakeup/${year}/${month}`
      );
      const casesResult = await response.json();
      casesResult.sort(sortFuncLakeReport);
      resolve(casesResult);
    });
  },

  pullNewWells(year, month) {
    return new Promise(async (resolve, reject) => {
      const { apiUrl } = window['config'];
      const response = await fetch(
        `${apiUrl}/appendix/newWells/${year}/${month}`
      );
      const casesResult = await response.json();
      casesResult.sort(sortFuncLakeReport);
      resolve(casesResult);
    });
  },

  pullTakeNoAction(year, month) {
    return new Promise(async (resolve, reject) => {
      const { apiUrl } = window['config'];
      const response = await fetch(
        `${apiUrl}/appendix/takeNoAction/${year}/${month}`
      );
      const casesResult = await response.json();
      casesResult.sort(sortFunc);
      resolve(casesResult);
    });
  },

  getHearing(year, month) {
    return new Promise(async (resolve, reject) => {
      const { apiUrl } = window['config'];
      const response = await fetch(
        `${apiUrl}/appendix/hearing/${year}/${month}`
      );
      const hearing = await response.json();
      resolve(hearing);
    });
  },

  getPermits(permitNumbers) {
    return new Promise(async (resolve, reject) => {
      const { apiUrl } = window['config'];
      const response = await fetch(`${apiUrl}/permit/${permitNumbers}`);
      const permits = await response.json();
      resolve(permits);
    });
  },

  getYear(permit) {
    return new Date(permit.DATE_CREATED).getUTCFullYear();
  },

  getTermBeginYear(permit) {
    return new Date(permit.DATE_ACCEPTED).getUTCFullYear();
  },

  getTermEndYear(permit) {
    return new Date(permit.EXPIRATION_DATE).getUTCFullYear();
  },

  getLeadWellNumber(permit) {
    const value = permit.dataGroups.filter(
      (dg) => dg.GROUP_CODE === 'WELLNUMBER'
    )[0].dataDetails[0].NUMBER_VALUE;
    return Math.round(value);
  },

  getDiameter(permit) {
    return new Promise(async (resolve, reject) => {
      const { apiUrl } = window['config'];
      const response = await fetch(`${apiUrl}/well/${permit.CASE_NAME}`);
      const diameter = await response.json();
      resolve(diameter);
    });
  },

  getReportYear(permit) {
    const realDate = new Date(permit.DATE_CREATED);
    if (realDate.getMonth() <= 4) {
      // Jan - May
      return realDate.getUTCFullYear() - 2;
    } else {
      return realDate.getUTCFullYear() - 1;
    }
  },

  getAnnualReportPumpage(permit) {
    return new Promise(async (resolve, reject) => {
      const wellNo = this.getLeadWellNumber(permit);
      // const year = this.getReportYear(permit);
      const year = new Date(permit.DATE_CREATED).getUTCFullYear();
      const { apiUrl } = window['config'];
      const response = await fetch(
        `${apiUrl}/permit/annualReportPumpage/${wellNo}/${year}`
      );
      const { reportYear, pumpage } = await response.json();
      resolve({ reportYear, pumpage });
    });
  },

  getRegArea(permit) {
    if (permit.registrationArea.length > 0) {
      return permit.registrationArea[0].VALUE;
    } else {
      return '';
    }
  },

  getDistrictPlanCompliance(permit) {
    const dataGroup = permit.dataGroups.filter(
      (dg) => dg.GROUP_CODE === 'WPDISTCOMP'
    )[0];
    if (dataGroup) {
      return dataGroup.dataDetails.filter(
        (dd) => dd.DETAIL_CODE === 'WPDISTCOMP'
      )[0].LIST_VALUE;
    } else {
      return '';
    }
  },

  getPrev12MGroundwater(permit) {
    const wppermitDataGroup = permit.dataGroups.filter(
      (dg) => dg.GROUP_CODE === 'WPPERMIT'
    );
    if (wppermitDataGroup.length > 0) {
      const prev12 = wppermitDataGroup[0].dataDetails.filter(
        (dd) => dd.DETAIL_CODE === 'GWPREV12MO'
      );
      if (prev12.length > 0) {
        return prev12[0].NUMBER_VALUE;
      }
    }
    return '';
  },

  getPrev12MAlternateWater(permit) {
    const dataDetail = permit.dataGroups.filter(
      (dg) => dg.GROUP_CODE === 'WPPERMIT'
    );
    if (dataDetail.length > 0) {
      const altWater = dataDetail[0].dataDetails.filter(
        (dd) => dd.DETAIL_CODE === 'ALTWATER'
      );
      if (altWater.length > 0) {
        return altWater[0].VALUE == null ? 0 : altWater[0].VALUE;
      }
    }
    return 0;
  },

  getAllocationAmount(permit) {
    return new Promise(async (resolve, reject) => {
      const { apiUrl } = window['config'];
      const response = await fetch(
        `${apiUrl}/permit/previousAllocation/${permit.CA_OBJECT_ID}`
      );
      const { termBegin, termEnd, allocation } = await response.json();
      resolve({
        termBegin,
        termEnd,
        allocation,
      });
    });
    // Gets previous permit information

    // const dataGroup = permit.dataGroups.filter(
    //   (dg) => dg.GROUP_CODE === 'WPALLOCAT'
    // );
    // if (dataGroup.length > 0) {
    //   const dataDetail = dataGroup[0].dataDetails.filter(
    //     (dd) => dd.DETAIL_CODE === 'PERMITALLO'
    //   );
    //   if (dataDetail.length > 0) {
    //     return dataDetail[0].VALUE == null ? 0 : dataDetail[0].VALUE;
    //   }
    // }
    // return 0;
  },

  getRequestedAmount(permit) {
    const dataGroup = permit.dataGroups.filter(
      (dg) => dg.GROUP_CODE === 'WPPERMIT'
    );
    if (dataGroup.length > 0) {
      const dataDetail = dataGroup[0].dataDetails.filter(
        (dd) => dd.DETAIL_CODE === 'REQUESTMG'
      );
      if (dataDetail.length > 0) {
        return dataDetail[0].VALUE == null ? 0 : dataDetail[0].VALUE;
      }
    }
    return 0;
  },

  getRecommendationAmount(permit) {
    const dataGroups = permit.dataGroups.filter(
      (dg) => dg.GROUP_CODE === 'WPALLOCAT'
    );
    if (dataGroups.length > 0) {
      const dataDetails = dataGroups[0].dataDetails.filter(
        (dd) => dd.DETAIL_CODE === 'PERMITALLO'
      );
      if (dataDetails.length > 0) {
        return dataDetails[0].VALUE == null ? 0 : dataDetails[0].VALUE;
      }
    }
    return 0;
  },

  getTerm(permit) {
    return `${dateFormat(
      permit.DATE_ACCEPTED,
      DATE_FORMAT,
      true
    )} - ${dateFormat(permit.DATE_EXPIRATION, DATE_FORMAT, true)}`;
    // const dataGroups = permit.dataGroups.filter(
    //   (dg) => dg.GROUP_CODE === 'WPPERMIT'
    // );
    // if (dataGroups.length > 0) {
    //   const beginDates = dataGroups[0].dataDetails.filter(
    //     (dd) => dd.DETAIL_CODE === 'CURTERMBEG'
    //   );
    //   if (beginDates.length > 0) {
    //     const beginDate = beginDates[0].DATE_VALUE;
    //     const endDates = dataGroups[0].dataDetails.filter(
    //       (dd) => dd.DETAIL_CODE === 'CURTERMEND'
    //     );
    //     if (endDates.length > 0) {
    //       const endDate = endDates[0].DATE_VALUE;
    //       return `${dateFormat(beginDate, DATE_FORMAT, true)} - ${dateFormat(
    //         endDate,
    //         DATE_FORMAT,
    //         true
    //       )}`;
    //     }
    //   }
    // }
    // return '';
  },

  getExpiringTerm(permit) {
    const dataGroups = permit.dataGroups.filter(
      (dg) => dg.GROUP_CODE === 'WPPERMIT'
    );
    if (dataGroups.length > 0) {
      const beginDates = dataGroups[0].dataDetails.filter(
        (dd) => dd.DETAIL_CODE === 'CURTERMBEG'
      );
      if (beginDates.length > 0) {
        const beginDate = beginDates[0].DATE_VALUE;
        const endDates = dataGroups[0].dataDetails.filter(
          (dd) => dd.DETAIL_CODE === 'CURTERMEND'
        );
        if (endDates.length > 0) {
          const endDate = endDates[0].DATE_VALUE;
          return `${dateFormat(beginDate, DATE_FORMAT, true)} - ${dateFormat(
            endDate,
            DATE_FORMAT,
            true
          )}`;
        }
      }
    }
    return '';
  },

  getLocation(permit) {
    return permit.LOCATION;
  },

  getStatus(permit) {
    const statuses = permit.tasks.filter((t) => t.TASK_CODE === 'WPVERIFAPP');
    if (statuses.length > 0) {
      return statuses[0].RESULT_CODE;
    }
    return '';
  },

  getRecommendations(permit) {
    const notes = permit.notes.filter(
      (n) => n.code && n.code.substring(0, 3) === 'RE-'
    );
    const text = [];
    notes.forEach((note) => {
      const notesString = note.NOTES;
      text.push(notesString.replace(/(\d\)\s)/g, '|$1').split('|'));
    });
    return text;
  },

  getTestimony(permit) {
    const testimonies = permit.notes.filter(
      (n) => n.code && n.code.substring(0, 3) === 'TF-'
    );
    const text = [];
    testimonies.forEach((note) => {
      const notesString = testimonies[0].NOTES;
      text.push(notesString.replace(/([?!])\s*/g, '$1|').split('|'));
    });
    return text;
  },
};

export default ReportBuilder;
